'use client'

import Image from 'next/image'
import aliancaNegativo from '+/alianca-negativo.svg'
import s from './styles.module.scss'
import Link from 'next/link'
import {McButton} from '@maersk-global/mds-react-wrapper/components-core/mc-button'
import {McDrawer} from '@maersk-global/mds-react-wrapper/components-core/mc-drawer'
import {useEffect, useState} from 'react'
import {useRouter} from 'next/router'
import {useUserStore} from '@/providers/userProvider'
import {isTokenValid} from '@/utils/token'
import OrdersService from '@/services/http/orders'
import {useQueryClient} from '@tanstack/react-query'
import {useGetMenuItems} from '@/components/Navbar/hooks'

const Navbar = () => {
  const router = useRouter()
  const queryClient = useQueryClient()
  const {user, token, logout} = useUserStore()
  const [isSideModalOpen, setIsSideModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const menuItems = useGetMenuItems()
  const sideItems = [
    {
      label: 'Nome',
      value: user?.nome,
    },
    {
      label: 'Razão Social',
      value: user?.razaoSocial,
    },
    {
      label: 'Inscrição Estadual',
      value: user?.inscricaoEstadual,
    },
  ]

  useEffect(() => {
    const prefetch = () => {
      if (token) {
        queryClient.prefetchQuery({
          queryKey: ['orderExplanations'],
          queryFn: OrdersService.getOrderExplanations,
        })
        queryClient.prefetchQuery({
          queryKey: ['containerTypes'],
          queryFn: OrdersService.getContainerTypes,
        })
      }
    }

    prefetch()
  }, [queryClient, token])

  useEffect(() => {
    if (user && !isTokenValid(user.exp)) {
      logout()
      router.replace({
        pathname: '/',
        query: {expired: true},
      })
    }
  }, [logout, router, user])

  const logoutUser = async () => {
    try {
      setIsLoading(true)
      await router.push('/')
      logout()
    } finally {
      setIsSideModalOpen(false)
      setIsLoading(false)
    }
  }

  const handleUserButton = () => {
    if (user) {
      setIsSideModalOpen(true)
    } else {
      router.push('/')
    }
  }

  return (
    <>
      <nav className={s.container}>
        <div className={s.container__content}>
          <Link href={user ? '/ordens' : '/home'} data-cy-item="navbar-a-logo">
            <Image
              src={aliancaNegativo}
              alt="Logotipo Aliança"
              className={s.logo}
            />
          </Link>
          <menu className={s.menu}>
            <div className={s.menu__left}>
              {menuItems.map(item => (
                <Link
                  className={s.menuItem}
                  key={item.name}
                  href={item.href}
                  data-cy-item={`navbar-a-${item.name}`}>
                  {item.name}
                  {/*{pathName === item.href && (*/}
                  {/*  <span className={s.menuItem__border} />*/}
                  {/*)}*/}
                </Link>
              ))}
            </div>
          </menu>
          <div>
            <McButton
              data-cy-item={user ? 'navbar-btn-user' : 'navbar-btn-entrar'}
              fit="large"
              label={user ? `Olá, ${user.nome}` : 'Entrar'}
              variant="plain"
              appearance="inverse"
              onClick={handleUserButton}
              trailingicon="user-circle"
            />
          </div>
        </div>
      </nav>
      <McDrawer open={isSideModalOpen} closed={() => setIsSideModalOpen(false)}>
        <div className={s.sideContainer}>
          {sideItems.map(item => (
            <div className={s.sidebarItem} key={item.label}>
              <span className={s.sidebarItem__label}>{item.label}</span>
              <span className={s.sidebarItem__value}>{item.value}</span>
            </div>
          ))}
        </div>
        <div className={s.divider} />
        <McButton
          data-cy-item="navbar-btn-sair"
          onClick={logoutUser}
          label="Sair"
          fit="medium"
          width="full-width"
          variant="plain"
          icon="door-arrow-right"
          justifyitems="left"
          loading={isLoading}
        />
      </McDrawer>
    </>
  )
}

export default Navbar
